import { CaseList } from './case-list';
import { CaseDetail } from '@codametrix/shared-views';
import { CaseDetailv2 } from '@codametrix/shared-views';
import React, { useEffect, useState } from 'react';
import history from '../../../history';
import { useDispatch, useSelector } from 'react-redux';
import {
  AmplifyCore,
  appServiceLines,
  codeBenchActions,
  commonEnums as enums
} from '@codametrix/ui-common';

const { toServiceLineSlug, normalizeServiceLineName } = appServiceLines;

type DualComponentProps = {
  detailProps: any;
  detailMethods: any;
  listProps: any;
  listMethods: any;
  match: any;
};

const CaseListAndDetail = (props: DualComponentProps) => {
  const dispatch = useDispatch();

  const hasAmplifyCaseRunV2Access = useSelector((state: CMx.ApplicationState) =>
    state.ui.context.activeContext
      ? AmplifyCore.benchEditable.isResourceAllowed(
          state.ui.context.activeContext,
          enums.ResourceId.AMPLIFY_CASE_RUN_V2,
          state.ui.serviceLine?.name ?? 'default'
        )
      : false
  );

  const context = useSelector((state: CMx.ApplicationState) => {
    return state.ui.context;
  });

  const { params = {} } = props.match ?? {};

  const detailProps = {
    ...props.detailProps,
    ...props.detailMethods,
    tenantId: context.activeContext?.tenantId,
    hasAmplifyCaseRunV2Access
  };

  const listProps = {
    ...props.listProps,
    context,
    ...props.listMethods
  };

  const [isDetailOpen, setIsDetailOpen] = useState<boolean>(
    params.id !== undefined
  );

  const handleSelection = (item: CMxAPI.CaseRunV2) => {
    const serviceLineConfig = appServiceLines.determineServiceLineConfig({
      name: item.service_line,
      caseIdentifier: `${item.case_uid || item.case_id}`
    });

    const caseId =
      serviceLineConfig.caseIdProp in item
        ? item[serviceLineConfig.caseIdProp]
        : item.case_id;
    const serviceLine = toServiceLineSlug(normalizeServiceLineName(String(params.serviceLine ?? '')));
    const targetPath = `/cmx/cases/${serviceLine}/${caseId}/`;
    // Always push an absolute path. A bare segment (history.push(caseId)) is resolved
    // against the *last* URL path segment; without a trailing slash on /cmx/cases/:sl
    // that incorrectly becomes /cmx/cases/:caseId and breaks the stack for browser Back.
    if (history.location.pathname.replace(/\/$/, '') !== targetPath.replace(/\/$/, '')) {
      history.push(targetPath);
    }
    setIsDetailOpen(true);
  };

  const handleBackClick = (event: any) => {
    dispatch(codeBenchActions.showSideNavBar());
    history.push(`/cmx/cases/${toServiceLineSlug(normalizeServiceLineName(params.serviceLine ?? ''))}/`);
    setIsDetailOpen(false);
  };

  useEffect(() => {
    setIsDetailOpen(params.id !== undefined);
  }, [params.id]);

  useEffect(() => {
    dispatch(codeBenchActions.resetCursorAPIContext());
  }, [dispatch]);

  return (
    <>
      <div
        style={{
          display: isDetailOpen ? 'none' : 'flex',
          flexDirection: 'column',
          flex: '1 1 0',
          minHeight: 0
        }}>
        <CaseList {...listProps} onSelection={handleSelection} />
      </div>

      {isDetailOpen ? (
        hasAmplifyCaseRunV2Access ? (
          <CaseDetailv2
            {...detailProps}
            handleBackClick={handleBackClick}
            match={props.match}
            context={context}
          />
        ) : (
          <CaseDetail
            {...detailProps}
            handleBackClick={handleBackClick}
            match={props.match}
            context={context}
          />
        )
      ) : null}
    </>
  );
};

export { CaseListAndDetail };
